export default __webpack_public_path__ + "static/media/16t.a729af84.jpg";